var map = {
	"./AdmContratos.jpg": 8283,
	"./BannerRadiografia.png": 1877,
	"./Ecommerce2025.jpg": 1807,
	"./ExcelProf.jpg": 6754,
	"./RajoAbierto.jpg": 692,
	"./acceso-bg.jpg": 7732,
	"./af_img.png": 1517,
	"./bg-cta.png": 5351,
	"./casco.png": 6003,
	"./cta-img.png": 7114,
	"./cyberday2025.jpg": 898,
	"./foco-1.jpg": 7065,
	"./foco-2.jpg": 5566,
	"./foco-3.jpg": 5723,
	"./foco-4.jpg": 840,
	"./focos-img.png": 9230,
	"./gv_img.png": 9183,
	"./header-img-1.png": 8163,
	"./header-img-2.png": 3672,
	"./header-img-3.png": 1937,
	"./home-noticia-2-desktop.jpg": 4161,
	"./home-noticia-2-mobile.jpg": 2827,
	"./home-noticia-2-tablet.jpg": 5053,
	"./home1.jpg": 2256,
	"./imagen-portada-web.jpg": 2130,
	"./ld_img.png": 6644,
	"./servicio-1.jpg": 4326,
	"./servicio-2.jpg": 6465,
	"./servicio-3.jpg": 6516,
	"./servicio-4.jpg": 9247,
	"./servicio-5.jpg": 2866,
	"./servicio-5.png": 9494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;